import { render, staticRenderFns } from "./KakaoLoginComponent.vue?vue&type=template&id=03d620c0&scoped=true"
import script from "./KakaoLoginComponent.vue?vue&type=script&lang=js"
export * from "./KakaoLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d620c0",
  null
  
)

export default component.exports